"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Datepicker = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactDatepicker = _interopRequireWildcard(require("react-datepicker"));
var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));
var _utils = require("../utils");
var _ui = require("../../ui");
require("react-datepicker/dist/react-datepicker.css");
require("../../../src/ui/datepicker/datepicker.module.scss");
const _excluded = ["className", "color", "disabled", "editable", "label", "icon", "isClearable", "iconTooltip", "readOnly", "selected", "state", "value", "variant", "onChange"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const ReactDatepickerElement = _reactDatepicker.default;
(0, _reactDatepicker.registerLocale)('en-GB', _enGB.default); // Weeks start on Monday

// accessibility ok+-
// можно обновить до 3.4.1, там со скринридером всё хорошо, не нужны эти костыли, но проблемы с зависимостями
// upd 4.3.0

const Datepicker = exports.Datepicker = /*#__PURE__*/React.forwardRef((props, ref) => {
  let {
      className,
      color,
      disabled,
      editable,
      label,
      icon,
      isClearable,
      iconTooltip,
      readOnly,
      selected,
      state,
      value,
      variant,
      onChange
    } = props,
    attributes = _objectWithoutProperties(props, _excluded);
  className = (0, _utils.ClassNames)('kui-datepicker', disabled ? 'kui-datepicker--disabled' : null, readOnly ? 'kui-datepicker--readonly' : null, className);
  const datepickerRef = React.useRef(null);
  const pickerRef = React.useRef(null);
  isClearable = readOnly || disabled ? false : isClearable;
  editable = readOnly || disabled ? false : editable;
  const inputAttributes = {
    color,
    editable,
    icon,
    isClearable,
    iconTooltip,
    label,
    readOnly,
    ref,
    state,
    value,
    variant,
    onEnter: () => {
      if (!pickerRef.current.isCalendarOpen()) {
        pickerRef.current.onInputClick(); // open dropdown
      }
    }
  };
  const onChangeHandler = date => {
    if (onChange) onChange(date);
    setTimeout(() => {
      if (document.activeElement === document.body) {
        // фокус отвалился, вернуть фокус инпуту
        const input = datepickerRef.current.querySelector('input');
        if (input) input.focus();
      }
    }, 100);
  };
  const onBlurHandler = e => {
    if (e && e.relatedTarget) {
      const closest = e.relatedTarget.closest('.kui-datepicker');
      if (closest && closest === datepickerRef.current) return;
    }
    pickerRef.current.setOpen(false); // был баг: если убрать фокус табом, календарь не закрывается
  };
  const onKeyDown = e => {
    if (e && e.key === 'Escape') {
      e.stopPropagation();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    ref: datepickerRef,
    tabIndex: -1,
    onBlur: onBlurHandler
  }, /*#__PURE__*/React.createElement(ReactDatepickerElement, _extends({
    customInput: /*#__PURE__*/React.createElement(_ui.Input, inputAttributes),
    disabled: disabled,
    locale: "en-GB",
    readOnly: readOnly,
    ref: pickerRef,
    selected: selected,
    onChange: onChangeHandler,
    onKeyDown: onKeyDown
  }, attributes)));
});
Datepicker.defaultProps = {
  color: null,
  dateFormat: 'd MMM yyyy',
  editable: true,
  isClearable: true,
  iconTooltip: null,
  label: null,
  selected: null,
  value: '',
  variant: 'datepicker',
  onChange: () => undefined
};
Datepicker.displayName = 'Datepicker';